import { resolveImageSrc } from "../../api/axios";

export default function PT01({ module }) {
    return (
        <div className="w-full p-4">
            <div className="max-w-6xl mx-auto p-4 bg-white rounded-lg">
                <h2 className="text-3xl font-bold mb-6">{module.title}</h2>

                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    {module.items.map((item) => (
                        <div key={item.id} className="relative">
                            {item.picture1 && (
                                <img
                                    src={resolveImageSrc(item.picture1)}
                                    alt={item.alt_picture1 || ""}
                                    className="w-full h-auto rounded-lg shadow-md"
                                />
                            )}
                            <div className="absolute inset-0 flex items-center justify-center opacity-0 hover:opacity-100 hover:bg-white hover:bg-opacity-50 transition duration-300">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-12 w-12 text-white"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M15 10l4.553-4.553a1 1 0 00-1.414-1.414L13.586 8.586a2 2 0 01-2.828 0L5.861 3.861A1 1 0 004.447 5.275L9 10m6 4l4.553 4.553a1 1 0 01-1.414 1.414L13.586 15.414a2 2 0 00-2.828 0L5.861 20.139a1 1 0 01-1.414-1.414L9 14"
                                    />
                                </svg>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
